import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { SlotDataService } from "../slots-data.service";
import { SlotsService } from "../slots.service";
import { Router, ActivatedRoute } from "@angular/router";
import { LoaderService } from "../../shared/loader-spinner/index";
import { Subscription } from "rxjs/Subscription";
import { SlotsComponent } from "../slots.component";
import { SharedService } from "../../shared/services/shared.service";
import { TranslateService } from "@ngx-translate/core";
import { CssVarsService } from "../../shared/services/cssVarsService.service";
import { UserInfoService } from "../../shared/services/security.service";

@Component({
  selector: "app-booked-slots",
  templateUrl: "./booked-slots.component.html",
  styleUrls: ["./booked-slots.component.css"]
})
export class BookedSlotsComponent implements OnInit, OnDestroy {
  body;
  timezoneChangeSubscription: Subscription;
  public languageChange;
  allowCancellation : boolean = true;
  allowRescheduling : boolean = true;
  public companyName:string;
  public uiFooter;
  isRecruiter : boolean = false;
  public isExternal;
  public externalStyle;
  public isAppointmentDetailsAvaiable: boolean = false;

  constructor(
    public slotDataService: SlotDataService,
    private slotsService: SlotsService,
    private loaderService: LoaderService,
    private route: Router,
    private router : ActivatedRoute,
    private sharedService: SharedService,
    private translate: TranslateService,
    private cssVarsService: CssVarsService,
    private userInfoService : UserInfoService
  ) { }

  ngOnInit() {
    if('type' in this.router.snapshot.queryParams){
      this.router.snapshot.queryParams.type == "1" ? this.isRecruiter = true : this.isRecruiter = false;
    }else{
      this.isRecruiter = false;
    }
    if(!this.isRecruiter){
      this.allowRescheduling = this.slotDataService.allowRescheduling;
      this.allowCancellation = this.slotDataService.allowCancellation;
    }
    this.sharedService.isExternal = this.router.snapshot.queryParams["isExternal"];
    this.sharedService.externalStyle = this.router.snapshot.queryParams["isExternalStyle"];
    this.isExternal = this.sharedService.isExternal;
    this.externalStyle = this.sharedService.externalStyle;
    if(this.externalStyle){
      this.externalStyle = JSON.parse(this.externalStyle);
    }
    this.timeZoneChangeListener();
    this.companyName = this.slotDataService.getCompnayName();
    this.languageChange = this.translate.currentLang;
    this.uiFooter = this.slotDataService.getUiFooter();
    this.translate.onLangChange.subscribe(language => {
      this.languageChange = language.lang;
      this.changeMessage();
    });
    if(this.slotDataService.appointmentDetail.AppointmentTypeDescription && Object.keys(this.slotDataService.appointmentDetail.AppointmentTypeDescription).length > 0){
      this.isAppointmentDetailsAvaiable = true;
    }
  }

  changeMessage() {
    if (
      this.languageChange === "nl-NL" &&
      this.slotDataService.appointmentDetail.ConfirmationText
    ) {
      this.slotDataService.appointmentDetail.ConfirmationText =
        "Je hebt al een afspraak gemaakt voor deze uitnodiging!";
    } else if (
      this.languageChange === "en-US" &&
      this.slotDataService.appointmentDetail.ConfirmationText
    ) {
      this.slotDataService.appointmentDetail.ConfirmationText =
        "You already scheduled an appointment for this invite!";
    }else if (
      this.languageChange === "pl-PL" &&
      this.slotDataService.appointmentDetail.ConfirmationText
    ) {
      this.slotDataService.appointmentDetail.ConfirmationText =
        "Już ustawiłeś termin na to spotkanie";
    }else{
      this.slotDataService.appointmentDetail.ConfirmationText =
        "Sie haben bereits einen Termin für diese Einladung vereinbart!";
    }
  }

  /**
   * @description Function to listen to timezone change
   * and change the date format accordingly
   */
  timeZoneChangeListener() {
    this.timezoneChangeSubscription = this.slotsService
      .isTimezoneChange()
      .subscribe(timeZoneChanged => {
        this.loaderService.show();
        this.slotsService
          .getAppointmentSlots(1, this.slotDataService.appointmentCode,this.isRecruiter ? 1 : 2, "", true)
          .subscribe(
            data => {
              this.uiFooter = data.UiFooter;
                this.cssVarsService.setVariables({
                  '--primary-color': data.PrimaryBrandingColor,
                  '--secondary-color': data.SecondaryBrandingColor
                });
                this.slotDataService.setLogoUrlAndCompanyName(data.LogoUrl, data.CompanyName);
                this.companyName = data.CompanyName;
              this.slotDataService.setLogoUrlAndCompanyName(data.LogoUrl, data.CompanyName)
              this.loaderService.hide();
              this.slotDataService.setAppointMentDetail(data);
            },
            error => {
              this.loaderService.hide();
            }
          );
      });
  }

  /**
   * Cancel Appointment
   */
  cancelAppointment() {
    this.body = {
      appointmentCode: this.slotDataService.getAppointmentCode(),
      isClient: this.isRecruiter ? false : true,
      note: "",
      sendMail: true,
      leadUserInfo: this.slotDataService.getLeadUserInfo(),
      officeInfo: this.slotDataService.getAppointMentDetail().OfficeInfo,
      filePath:[]
    };
    this.loaderService.show();
    this.slotsService.cancelAppointment(this.body, true).subscribe(
      data => {
        this.loaderService.hide();
        this.sharedService.getTranslatedNotification(12);

        let queryParamsToApply:any = {};

        queryParamsToApply["AppointmentCode"] = this.slotDataService.getAppointmentCode();
        queryParamsToApply["type"] =  this.isRecruiter ? 1 : 2;
        
        if(this.sharedService.isExternal && (this.sharedService.isExternal === true || this.sharedService.isExternal === "true")){
          queryParamsToApply["isExternal"] =  this.sharedService.isExternal;
          queryParamsToApply["lang"] =  this.sharedService.externalLang;
          queryParamsToApply["isExternalStyle"] =  this.sharedService.externalStyle;

        }
        this.route.navigate(["slots"], {
          queryParams: queryParamsToApply
        });
        window.parent.postMessage({
          'message': 'success',
          'isSlotBook' : false
        }, "*");
      },
      error => {
        this.loaderService.hide();
        this.sharedService.setErrorMessage({
          status: error.status,
          message: error.json().message
        });
        this.route.navigate(["/error"]);
      }
    );
  }

  /**
   * Reschedule appointment
   */
  rescheduleAppointment() {
    this.slotDataService.hasReschedule = true;
    let queryParamsToApply:any = {};

    queryParamsToApply["AppointmentCode"] = this.slotDataService.getAppointmentCode();
    queryParamsToApply["type"] =  this.isRecruiter ? 1 : 2;
    
    if(this.sharedService.isExternal && (this.sharedService.isExternal === true || this.sharedService.isExternal === "true")){
      queryParamsToApply["isExternal"] =  this.sharedService.isExternal;
      queryParamsToApply["lang"] =  this.sharedService.externalLang;
      queryParamsToApply["isExternalStyle"] =  this.sharedService.externalStyle;
    }

    this.route.navigate(["slots/reschedule"], {
      queryParams: queryParamsToApply
    });
  }

  ngOnDestroy() {
    this.timezoneChangeSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/slots/booked-slots/booked-slots.component.ts